import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`gcc is deprecated now. Use clang!`}</p>
    <h1>{`GCC vs Clang++`}</h1>
    <p>{`Short story: GCC is slow, old (consider compiling a C++17 package in `}<a parentName="p" {...{
        "href": "https://www.redhat.com/en/technologies/linux-platforms/enterprise-linux"
      }}>{`RHEL`}</a>{`), GPL, not hackable;
while `}<a parentName="p" {...{
        "href": "https://clang.llvm.org/"
      }}>{`Clang`}</a>{` changes everyting above plus having its family support from `}<a parentName="p" {...{
        "href": "https://llvm.org/"
      }}>{`LLVM`}</a>{`.
If you don't care about programming at operating system level and don't need to maintain legacy code that solely relies on GCC, this is definitely a benefitial move.`}</p>
    <h1>{`One Button`}</h1>
    <p>{`Chandler Carruth's `}<a parentName="p" {...{
        "href": "https://youtu.be/uZI_Qla4pNA"
      }}>{`"LLVM: A Modern, Open C++ Toolchain"`}</a>{` is a very nice talk to know more about modern toolchain for C++. What I found inspiring is how `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`modern`}</code>{` clang becomes. Below is a script drawn from the talk to download everything and build your clang from scratch.`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`git`}</span>{` clone git://github.com/ninja-build/ninja.git
`}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`cd`}</span>{` ninja
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`git`}</span>{` checkout release
./configure.py `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`--bootstrap`}</span>{`

`}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`cd`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`..`}</span>{` 
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`git`}</span>{` clone `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`--depth`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` https://llvm.org/git/llvm.git `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# Don't clone everything`}</span>{`

`}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`cd`}</span>{` llvm/tools 
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`git`}</span>{` clone `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`--depth`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` https://llvm.org/git/clang.git
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`git`}</span>{` clone `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`--depth`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` https://llvm.org/git/lld.git

`}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`cd`}</span>{` clang/tools
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`git`}</span>{` clone `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`--depth`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` https://llvm.org/git/clang-tools-extra.git extra

`}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`cd`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`..`}</span>{`/`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`..`}</span>{`/`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`..`}</span>{`/projects
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`git`}</span>{` clone `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`--depth`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` https://llvm.org/git/libcxx.git
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`git`}</span>{` clone `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`--depth`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` https://llvm.org/git/libcxxabi.git
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`git`}</span>{` clone `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`--depth`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` https://llvm.org/git/compiler-rt.git 

`}<span parentName="code" {...{
            "className": "token function"
          }}>{`mkdir`}</span>{` build `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&&`}</span>{` `}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`cd`}</span>{` build
cmake `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`..`}</span>{` `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-GNinja`}</span>{`  `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-DCMAKE_MAKE_PROGRAM`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token variable"
          }}><span parentName="span" {...{
              "className": "token variable"
            }}>{`$(`}</span><span parentName="span" {...{
              "className": "token builtin class-name"
            }}>{`pwd`}</span><span parentName="span" {...{
              "className": "token variable"
            }}>{`)`}</span></span>{`/`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`..`}</span>{`/`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`..`}</span>{`/ninja/ninja `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-DCMAKE_BUILD_TYPE`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`Release `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-DCMAKE_INSTALL_PREFIX`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token environment constant"
          }}>{`$HOME`}</span>{`/.local/ `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-DCOMPILER_RT_INCLUDE_TESTS`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`OFF `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-DLLVM_ENABLE_ASSERTIONS`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`OFF

`}<span parentName="code" {...{
            "className": "token variable"
          }}><span parentName="span" {...{
              "className": "token variable"
            }}>{`$(`}</span><span parentName="span" {...{
              "className": "token builtin class-name"
            }}>{`pwd`}</span><span parentName="span" {...{
              "className": "token variable"
            }}>{`)`}</span></span>{`/`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`..`}</span>{`/`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`..`}</span>{`/ninja/ninja `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&&`}</span>{` `}<span parentName="code" {...{
            "className": "token variable"
          }}><span parentName="span" {...{
              "className": "token variable"
            }}>{`$(`}</span><span parentName="span" {...{
              "className": "token builtin class-name"
            }}>{`pwd`}</span><span parentName="span" {...{
              "className": "token variable"
            }}>{`)`}</span></span>{`/`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`..`}</span>{`/`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`..`}</span>{`/ninja/ninja `}<span parentName="code" {...{
            "className": "token function"
          }}>{`install`}</span></code></pre></div>
    <p>{`Finally, some finishing touch:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`CXX`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token variable"
          }}><span parentName="span" {...{
              "className": "token variable"
            }}>{`$(`}</span><span parentName="span" {...{
              "className": "token function"
            }}>{`which`}</span>{` clang++`}<span parentName="span" {...{
              "className": "token variable"
            }}>{`)`}</span></span>{`
`}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`CC`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token variable"
          }}><span parentName="span" {...{
              "className": "token variable"
            }}>{`$(`}</span><span parentName="span" {...{
              "className": "token function"
            }}>{`which`}</span>{` clang`}<span parentName="span" {...{
              "className": "token variable"
            }}>{`)`}</span></span></code></pre></div>
    <p>{`I actually use this `}<a parentName="p" {...{
        "href": ""
      }}>{`script`}</a>{` to install Clang in my local dotfiles environment.`}</p>
    <h1>{`Compiler at Your Finger Tip`}</h1>
    <p>{`Now after a few minute wait, you got the new freshly baked c++ compiler. No root permission or any painful dependency packages needed. Even though C++ seems to be the hardest language to apply `}<a parentName="p" {...{
        "href": "https://buckaroo.pm/"
      }}>{`modern package management`}</a>{`, I still hope C++ community will eventually come up with a `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`npm`}</code>{` equivalent public code repo/package manager at least working for most *nix system. `}</p>
    <h1>{`Side Notes`}</h1>
    <p>{`If you lead a Pythonful life, to install `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`cmake`}</code>{` you can simply run `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`pip install cmake`}</code>{` and upgrade becomes easier.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      